module.exports = __webpack_public_path__ + "media/images/icons/wizard/progress/middle-active-379d3b161e3b853ffb7dd7ce3c92a66e.svg";